module.exports = __webpack_public_path__ + "img/user.9ac238c7.svg";